import { render, staticRenderFns } from "./PurchaseCancelled.vue?vue&type=template&id=5c67de3a&scoped=true&"
import script from "./PurchaseCancelled.vue?vue&type=script&lang=js&"
export * from "./PurchaseCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c67de3a",
  null
  
)

export default component.exports